import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerEntitlementsComponent } from './customer-entitlements.component';

const routes: Routes = [{ path: '', component: CustomerEntitlementsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerEntitlementsRoutingModule {}
